import { z } from 'zod'

// ============================================================================
// SMS Types - Must match Edge Function payload exactly
// ============================================================================

/**
 * Valid SMS types supported by the send-sms Edge Function.
 */
export const SMS_TYPES = ['order_ready', 'pickup_code', 'delivery_update', 'magic_link', 'custom'] as const
export type SmsType = (typeof SMS_TYPES)[number]

/**
 * Zod schema for SendSmsRequest - validates payload before sending to Edge Function.
 */
export const sendSmsRequestSchema = z.object({
  to: z.string().min(1, 'Phone number is required'),
  message: z.string().min(1, 'Message is required').max(160, 'Message too long (max 160 chars)'),
  sms_type: z.enum(SMS_TYPES),
  order_id: z.number().optional(),
  organization_id: z.string().optional(),
})

export type SendSmsRequest = z.infer<typeof sendSmsRequestSchema>

/**
 * Response from the send-sms Edge Function.
 */
export interface SendSmsResponse {
  success: boolean
  message_id?: string
  error?: string
}

/**
 * Input for useSendSms hook mutation.
 */
export interface SendSmsInput {
  to: string
  message: string
  smsType: SmsType
  orderId?: number
  organizationId?: string
}
